<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <template #default>
        <span class="font-weight-medium text-h6">{{ titulo }}</span>

        <div class="d-flex justify-end mr-2">
          <v-tooltip
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                fab
                x-small
                v-on="on"
                @click="deletarEndereco"
              >
                <v-icon>
                  {{ icons.mdiDelete }}
                </v-icon>
              </v-btn>
            </template>
            <span>Deletar endereço</span>
          </v-tooltip>
        </div>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <solicitante-endereco-form
        :endereco-data="endereco"
        :atualizar-endereco="atualizarEndereco"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mdiDelete } from '@mdi/js'
import { computed } from '@vue/composition-api'
import SolicitanteEnderecoForm from './SolicitanteEnderecoForm.vue'

export default {
  components: {
    SolicitanteEnderecoForm,
  },

  props: {
    endereco: {
      type: Object,
      required: true,
    },
    atualizarEndereco: {
      type: Function,
      required: true,
    },
    deletarEndereco: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const titulo = computed(() => (props.endereco.nome ? `Endereço: ${props.endereco.nome}` : 'Endereço'))

    return {
      titulo,
      icons: {
        mdiDelete,
      },
    }
  },
}
</script>
